import React from "react";
import "../styles/landingpage.css"; // ✅ import custom CSS

import AnimatedTopSection from "../components/AnimatedTopSection";
import ContactForm from "../components/ContactForm";
import TariffPlans from "../components/TvInfoComponent";
import ConnectionPlans from "../components/ConnectionPlans";
import Header from "../components/Header";
import Footer from "../components/Footer";

const LandingPage = () => {
    return (
        <div className="landing-container flex flex-col min-h-screen text-gray-900">
            {/* Վերևի Header-ը մնում ա միշտ երևացող */}
            <div className="sticky-header sticky top-0 z-50 bg-white">
                <Header />
            </div>

            {/* Հիմնական բովանդակություն */}
            <main className="main-section flex-grow">
                <AnimatedTopSection />
                {/*<TariffPlans />*/}
                <ConnectionPlans />
                <ContactForm />
            </main>

            {/* Ներքևի Footer */}
            <Footer />
        </div>
    );
};

export default LandingPage;
